import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  FormControl,
  FormField,
  FormItem,
} from '@/shared/components';
import { cn } from '@/shared/utils';
import type { Control, FieldValues, Path } from 'react-hook-form';

interface WithdrawIncludeFeeFormFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  visible?: boolean;
  translationKey?: string;
  className?: string;
}

export function WithdrawIncludeFeeFormField<T extends FieldValues>({
  control,
  name,
  visible = true,
  translationKey = 'withdrawMethods.includeFeeLabel',
  className,
}: WithdrawIncludeFeeFormFieldProps<T>) {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(!visible && 'hidden', className)}>
          <label className="flex flex-row items-center gap-[1.6rem] p4 cursor-pointer px-[1.6rem]">
            <FormControl>
              <Checkbox
                className="cursor-pointer"
                checked={Boolean(field.value)}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div>{t(translationKey)}</div>
          </label>
        </FormItem>
      )}
    />
  );
}
